import React from 'react';
import { Typography, Box } from '@mui/material';

export const EmptyChatClient = () => {
  return (
    <Box
      sx={{
        px: 2,
        py: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'center',
        flexGrow: 1,
      }}
    >
      <Typography sx={{ mt: 3, color: 'text.secondary' }}>
        👋 Welcome! Share your skin concerns, goals, or details about your
        current skincare routine. You can also send a photo of your skin (clean,
        with no makeup) to help your esthetician better understand your skin!
      </Typography>

      <Typography sx={{ mt: 3, color: 'text.secondary' }}>
        Estheticians typically respond within 1-3 business days, but if you need
        additional assistance, please reach out to hello@pompbeauty.com
      </Typography>
    </Box>
  );
};
